import { vuexFilterBase } from '@/store/composition/utils/query/filter'
import { vuexPaginationBase } from '@/store/composition/utils/query/pagination'
import { vuexSortBase } from '@/store/composition/utils/query/sort'
import { vuexLoadingBase } from '@/store/composition/utils/loading'
import { loadList } from '@/store/composition/utils/data/actions'
import { prepareFormDataId } from '@/utils/form/prepareFormDataId'

import { CHANGELOG_URL, EChangelogType } from '@/api/changelog'
import { getUserFullName } from '@/utils/user'

const state = () => ({
  ...vuexFilterBase.createState(),
  ...vuexPaginationBase.createState(),
  ...vuexSortBase.createState(),
  ...vuexLoadingBase.createState(),

  urlApi: CHANGELOG_URL + `?search[type]=${EChangelogType.pto}`,
  expand: 'user',
  list: [],
  tableHeaders: [
    {
      title: 'Дата/время изменений',
      isSortable: true,
      sortName: 'created_at'
    },
    {
      title: 'Кто изменил',
      isSortable: true,
      sortName: 'user.surname'
    },
    {
      title: 'Объект изменения',
      isSortable: true,
      sortName: 'loggable_object|object_number'
    },
    {
      title: 'Событие',
      isSortable: true,
      sortName: 'event'
    },
    {
      title: 'Было',
      isSortable: true,
      sortName: 'before'
    },
    {
      title: 'Стало',
      isSortable: true,
      sortName: 'after'
    }
  ],
  filterValue: {}
})

const getters = {
  ...vuexPaginationBase.createGetters(),
  ...vuexLoadingBase.createGetters(),
  getTableHeaders: state => state.tableHeaders,
  visibleTable: (state) => {
    return state.list.length
  },
  getList: (state) => {
    return state.list.map(item => ({
      id: item.id,
      values: [
        { data: item.created_at, mod: 'date' },
        getUserFullName(item.user) || '-',
        `${item.loggable_object} ${item.object_number}` || '-',
        item.event || '-',
        item.before || '-',
        item.after || '-'
      ]
    }))
  },
  getFilterValue: (state) => state.filterValue
}

const mutations = {
  ...vuexFilterBase.createMutations(),
  ...vuexPaginationBase.createMutations(),
  ...vuexSortBase.createMutations(),
  ...vuexLoadingBase.createMutations(),
  SET_LIST: (state, list) => {
    state.list = list
  },
  SET_FILTER_VALUE: (state, filter) => {
    state.filterValue = filter
  },
  RESET_STORE: (state) => {
    state.list = []

    // query params
    state.sort = {
      name: 'id',
      descending: true
    }
    // state.filter = {}
    state.pagination.currentPage = 1
  }
}

const actions = {
  loadList,
  ...vuexFilterBase.createActions(),
  ...vuexPaginationBase.createActions(),
  ...vuexSortBase.createActions(),
  goToPageById: () => {},

  async loadFilter ({ commit, dispatch }, filter = {}) {
    commit('SET_CURRENT_PAGE', 1)
    commit('SET_FILTER_VALUE', filter)
    const keyList = [
      'user',
      'loggable_object'
    ]
    const prepareFormData = prepareFormDataId(filter, keyList)
    commit('SET_FILTER', prepareFormData)
    await dispatch('loadList')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
